import cnpj from './cnpj'
import cpf from './cpf'
import cpfOrCnpj from './cpfOrCnpj'
import file from './file'
import isArrayOf from './isArrayOf'
import isClear from './isClear'
import isValidEmail from './isValidEmail'
import jodit from './jodit'
import phone from './phone'

const validates = {
  cnpj,
  cpf,
  cpfOrCnpj,
  file,
  isArrayOf,
  isClear,
  isValidEmail,
  jodit,
  phone,
}

export default validates
